import React from 'react'
import styles from './styles.module.less'
export default ({ children, ...props }) => (
  <div className={styles.fullScreenCenter} {...props}>
    {children}
  </div>
)
